import { render, staticRenderFns } from "./handlephoto.vue?vue&type=template&id=43afb2bc"
import script from "./handlephoto.vue?vue&type=script&lang=js"
export * from "./handlephoto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports